// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8o7N2","comment":"styles_comment__OsS7M"};